const SESSION_STORAGE_KEY = 'peer-plus-session-id';

export const getOrCreateAnonymousSessionId = () => {
  if (typeof window === 'undefined') {
    return 'peer-plus-preview-session';
  }

  const existingSessionId = window.localStorage.getItem(SESSION_STORAGE_KEY);
  if (existingSessionId) {
    return existingSessionId;
  }

  const nextSessionId = `peer-plus-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  window.localStorage.setItem(SESSION_STORAGE_KEY, nextSessionId);
  return nextSessionId;
};